export default __webpack_public_path__ + "static/media/512x512.771e6cba.png";